export default __webpack_public_path__ + "static/media/aws_icon.50caac03.png";